import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@pwc/pwc-deals-ui';
import { BlankLayout } from './layouts';
import './UnexpectedError.scss';

const UnexpectedError = ({
  url = '/',
  text = 'Return to Projects',
  statusCode = '500',
  description = 'Internal Server Error',
}) => {
  return (
    <BlankLayout>
      <div
        className="unexpected-error-content"
        data-testid="unexpected-error-notification"
      >
        <h1 className="unexpected-error-content-header">{statusCode}</h1>
        <p>{description}</p>
        <Link to={url} aria-label={text}>
          <Button className="button-large">{text}</Button>
        </Link>
      </div>
    </BlankLayout>
  );
};

UnexpectedError.propTypes = {};

export default UnexpectedError;
